import FluxStore from "./FluxStore";

import AppConstants from "../constants/AppConstants";

import AppDispatcher from "../dispatcher/AppDispatcher";

let featureFlags = {};
let features = {};

class FeatureFlagStore extends FluxStore
{
	getFeatureFlags()
	{
		return featureFlags;
	}

	isEnabled(name)
	{
		return featureFlags[name] || false;
	}

	isFeatureEnabled(name)
	{
		return features[name] || false;
	}

	premiumAccountEnabled()
	{
		return featureFlagStore.isEnabled("premiumAccount");
	}

	importEnabled()
	{
		return featureFlagStore.isEnabled("import");
	}

	contactUsEnabled()
	{
		return featureFlagStore.isFeatureEnabled("contactUs");
	}
}

const featureFlagStore = new FeatureFlagStore();

featureFlagStore.dispatchToken = AppDispatcher.register((action) => {
	switch (action.actionType)
	{
		case AppConstants.FEATURE_RECEIVE_DATA:
			featureFlags = action.featureFlags;
			features = action.features;
			// Don't emit for this
			return true;

		default:
			return true;
	}

	// Disabled for now, can remove when we have another case here
	// eslint-disable-next-line no-unreachable
	featureFlagStore.emitChange();
	return true;
});

export default featureFlagStore;



// WEBPACK FOOTER //
// ./Components/stores/FeatureFlagStore.jsx